export default __webpack_public_path__ + "static/media/IMG_4582-min.49720da2.JPG";